import { render, staticRenderFns } from "./GetTheLoanTab.vue?vue&type=template&id=6a55c981&scoped=true"
import script from "./GetTheLoanTab.vue?vue&type=script&lang=js"
export * from "./GetTheLoanTab.vue?vue&type=script&lang=js"
import style0 from "./GetTheLoanTab.vue?vue&type=style&index=0&id=6a55c981&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a55c981",
  null
  
)

export default component.exports